export default __webpack_public_path__ + "static/media/NunitoSans-Bold.5edfb588.woff";